// Constants for demand notice edit operations

// Specific demand notice edit
export const DEMAND_SPECIFIC_EDIT_REQUEST = 'DEMAND_SPECIFIC_EDIT_REQUEST';
export const DEMAND_SPECIFIC_EDIT_SUCCESS = 'DEMAND_SPECIFIC_EDIT_SUCCESS';
export const DEMAND_SPECIFIC_EDIT_FAIL = 'DEMAND_SPECIFIC_EDIT_FAIL';
export const DEMAND_SPECIFIC_EDIT_RESET = 'DEMAND_SPECIFIC_EDIT_RESET';

// Batch demand notice edit
export const DEMAND_BATCH_EDIT_REQUEST = 'DEMAND_BATCH_EDIT_REQUEST';
export const DEMAND_BATCH_EDIT_SUCCESS = 'DEMAND_BATCH_EDIT_SUCCESS';
export const DEMAND_BATCH_EDIT_FAIL = 'DEMAND_BATCH_EDIT_FAIL';
export const DEMAND_BATCH_EDIT_RESET = 'DEMAND_BATCH_EDIT_RESET';
